import React, { PropsWithChildren, useCallback } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import CheckBox from '@Components/Selectors/Checkbox'
import { CheckboxGroupDiscriminatedProps, CheckboxGroupOption } from '@App/forms/common/checkbox-group-form-field'

const CheckboxGroupForm = ({
    name,
    mainColor = true,
    registerOptions,
    checkboxes,
    defaultValue,
    size,
    labelInfo,
    rounded = false,
    readonly,
    children,
}: PropsWithChildren<CheckboxGroupDiscriminatedProps<Record<string, unknown>>>) => {
    const { control } = useFormContext()

    // Handles adding/removing checkbox values in a concise, immutable way
    // Uses useCallback to avoid unnecessary re-renders
    const handleCheckboxChange = useCallback(
        (checked: boolean, id: string, value: string[] | undefined, onChange: (val: string[]) => void) => {
            const valueCopy = value ? [...value] : []
            const updated = checked
                ? [...valueCopy, id].filter((v, i, arr) => arr.indexOf(v) === i)
                : valueCopy.filter((item) => item !== id)
            onChange(updated)
        },
        []
    )

    return (
        <Controller
            name={name}
            control={control}
            rules={registerOptions}
            defaultValue={defaultValue ?? []}
            render={({ field: { value, onChange } }) => (
                <>
                    {checkboxes.map((checkbox: CheckboxGroupOption, index: number) => (
                        <CheckBox
                            key={checkbox.id || index}
                            mainColor={mainColor}
                            onClick={(state, id) => handleCheckboxChange(state, id, value, onChange)}
                            size={size}
                            labelInfo={labelInfo}
                            disabled={!!registerOptions && registerOptions.disabled}
                            id={checkbox.id}
                            checked={value ? value.includes(checkbox.id) : false}
                            readonly={readonly}
                            rounded={rounded}
                        >
                            {checkbox.children ?? checkbox.label}
                        </CheckBox>
                    ))}
                    {children}
                </>
            )}
        />
    )
}

export default CheckboxGroupForm
